import FieldComponent from 'Pages/GMS/ISR/Components/FieldComponent';
import RulesComponent from 'Pages/GMS/ISR/Components/Rules/RulesComponent';
import TextConfiguration from 'Pages/GMS/ISR/Components/TextConfiguration';
import React from 'react';
import { TConnector, TField, TFieldDataConfiguration, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import useFieldDataConfigurationUpdater from '../Hooks/useFieldDataConfigurationUpdater';
import AdditionalData from "../../../Components/AdditionalData";

type TextFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    createISRProject:()=>void;

}

const TextField = ({id, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo, createISRProject}: TextFieldProps) => {

    const { updateFieldConfiguration } = useFieldDataConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TFieldDataConfiguration) => {
        updateFieldConfiguration(indexInfo, updatedConfig, (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) ?? false);
    };

    return (
        <div id={id}>
            <FieldComponent 
                id={`${id}-field`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <TextConfiguration 
                id={`${id}-text-config`}
                selectedItem={selectedItem} 
                updateFieldDataConfiguration={updateFieldDataConfiguration}
            />
            <br />
            <AdditionalData 
                id={`${id}-additional-data`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <RulesComponent 
                id={`${id}-rules`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                createISRProject={createISRProject} 
                featureType="Field"
            />
        </div>
    );
}

export default TextField;